"use client";

export default function ImpersonationBanner({
  isImpersonating,
  impersonationTarget,
  exitImpersonation,
}: {
  isImpersonating: boolean;
  impersonationTarget: { name: string; email: string } | null;
  exitImpersonation: () => void;
}) {
  if (!isImpersonating || !impersonationTarget) return null;

  return (
    <div className="bg-amber-400 text-amber-950 px-4 md:px-6 py-2.5">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 min-w-0">
          <svg className="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
          </svg>
          <p className="text-sm font-medium">
            Viewing as <strong>{impersonationTarget.name}</strong> ({impersonationTarget.email})
          </p>
        </div>
        <button
          onClick={exitImpersonation}
          className="shrink-0 rounded-md bg-amber-950/20 px-3 py-1 text-xs font-semibold hover:bg-amber-950/30 transition-colors"
        >
          Exit Impersonation
        </button>
      </div>
    </div>
  );
}
